import styled from 'styled-components';

export const Root = styled.div`
  background: #f5f5f5;
  min-height: calc(100vh - 200px);
  padding: 24px;

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

export const BannerSection = styled.div`
  margin-bottom: 24px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  .ant-carousel {
    border-radius: 8px;
  }

  .ant-image {
    border-radius: 8px;
  }
`;

export const StaticBanner = styled.div`
  margin: 24px 0;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  .ant-image {
    width: 100%;
    display: block;
    border-radius: 8px;
  }

  @media (max-width: 768px) {
    margin: 16px 0;
  }
`;
